import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { id: "Cancel / Solid" }, [
      _createElementVNode("path", {
        id: "Vector",
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M11.75 2.00012C6.36522 2.00012 2 6.36535 2 11.7501C2 17.1349 6.36522 21.5001 11.75 21.5001C17.1348 21.5001 21.5 17.1349 21.5 11.7501C21.5 6.36535 17.1348 2.00012 11.75 2.00012ZM15.2803 9.28045C15.5732 8.98756 15.5732 8.51268 15.2803 8.21979C14.9874 7.9269 14.5126 7.9269 14.2197 8.21979L11.75 10.6895L9.28033 8.21979C8.98744 7.9269 8.51256 7.9269 8.21967 8.21979C7.92678 8.51268 7.92678 8.98756 8.21967 9.28045L10.6893 11.7501L8.21967 14.2198C7.92678 14.5127 7.92678 14.9876 8.21967 15.2805C8.51256 15.5733 8.98744 15.5733 9.28033 15.2805L11.75 12.8108L14.2197 15.2805C14.5126 15.5733 14.9874 15.5733 15.2803 15.2805C15.5732 14.9876 15.5732 14.5127 15.2803 14.2198L12.8107 11.7501L15.2803 9.28045Z"
      })
    ], -1)
  ])))
}
export default { render: render }